// Copyright (c) 2025. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './translations/en.ts';
import de from './translations/de.ts';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: en,
    de: de,
  },
});

export default i18n;
